import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../utils/config";
import NewTopNavBar from "./NewTopNavBar";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const SetOpenPlatform = () => {
  const [value, setValue] = useState("false");
  const [loading, setLoading] = useState(false);
  const [isDesable, setIsDesable] = useState(false);
  let bearerToken = localStorage.getItem("jwt_token");
  const navigate = useNavigate();
  const config = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
  };
  const userRoll = localStorage.getItem("roles");

  useEffect(() => {
    if (userRoll != "administrator") {
      setIsDesable(true);
    }
    // Fetch the current value from the WordPress option
    const fetchCurrentValue = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/wp-json/custom/v1/toggle-option`,
          config
        );
        if (response.data) {
          setValue(response.data.value ? "true" : "false");
        }
        setLoading(true);
      } catch (error) {
        console.error("Error fetching current option value:", error);
      }
    };
    fetchCurrentValue();
  }, [loading]);

  const handleChange = async (event) => {
    const newValue = event.target.value;
    setValue(newValue);
    console.log(newValue);
    try {
      const res = await axios.post(
        `${API_BASE_URL}/wp-json/custom/v1/toggle-option`,
        {
          value: newValue,
        },
        config
      );
      navigate("/");
      // console.log("line55=", res.data);
      // if(res.data)
    } catch (error) {
      console.error("Error updating option:", error);
    }
  };

  return (
    <>
      <div>
        <NewTopNavBar />
      </div>
      {loading ? (
        <div className="manage-open-platform-main-div">
          <div>
            <h2>Manage Platform</h2>
          </div>
          <div>
            <label className="fs-5 fw-bold pe-2">
              <input
                type="radio"
                value="true"
                checked={value === "true"}
                onChange={handleChange}
                style={{ width: "20px" }}
                disabled={isDesable}
              />
              Open
            </label>
            <label className="fs-5 fw-bold pe-2">
              <input
                style={{ width: "20px" }}
                type="radio"
                value="false"
                checked={value === "false"}
                onChange={handleChange}
                disabled={isDesable}
              />
              Protected
            </label>
          </div>
        </div>
      ) : (
        <div className="text-center pt-5">
          <Spinner />
        </div>
      )}
    </>
  );
};

export default SetOpenPlatform;
